/* eslint-disable @typescript-eslint/no-unused-vars */
import { RequestRejectionError } from '##/services/tenApi';
import { TealiumErrorData } from '##/services/analytics/Tealium/TealiumErrorTypes';

export type ErrorType =
  | 'NETWORK_ERROR'
  | 'GENERIC_ERROR'
  | 'LOCATION_ERROR'
  | 'PLAYBACK_ERROR';

type ErrorMapType = {
  [type in ErrorType]: string;
};

export const ERROR_MESSAGES_MAP: ErrorMapType = {
  NETWORK_ERROR: 'Oops, there’s been a network error...',
  GENERIC_ERROR: 'Oops, something went wrong...',
  LOCATION_ERROR: 'Oops, there’s been a location error...',
  PLAYBACK_ERROR: 'Oops, there’s been a playback error...',
};

export const ERROR_DESCRIPTION_MAP: ErrorMapType = {
  NETWORK_ERROR:
    'Please check your connection and then hit one of the back buttons below to try again.',
  GENERIC_ERROR:
    "Please hit one of the back buttons below and let's get you playing again.",
  LOCATION_ERROR:
    'Please check your connection and then hit one of the back buttons below to try again.',
  PLAYBACK_ERROR:
    "Please hit one of the back buttons below and let's get you playing again.",
};

export interface InternalErrorMessage {
  type: ErrorType;
}

export const HTTP_STATUS_CODE_MAP: {
  [code in number]?: ErrorType;
} = {
  0: 'NETWORK_ERROR',
  400: 'GENERIC_ERROR',
  403: 'GENERIC_ERROR',
  404: 'GENERIC_ERROR',
  410: 'GENERIC_ERROR',
  500: 'GENERIC_ERROR',
  502: 'GENERIC_ERROR',
  503: 'GENERIC_ERROR',
};

type NoErrorState = { hasError: false };
type ErrorState = { hasError: true; error: Error };

export type ErrorBoundaryState = NoErrorState | ErrorState;

type NoErrorScreen = { layout: 'NO_ERROR' };
type ErrorPageScreen = { layout: 'ERROR_PAGE'; error: ErrorType };

export type ErrorScreenState = NoErrorScreen | ErrorPageScreen;

export type ErrorScreenContextValue = {
  hasError: boolean;
  showError: (error: ErrorType) => void;
  clear: () => void;
  catchApiError: (error: RequestRejectionError) => void;
  sendErrorToTealium: (errorData: TealiumErrorData) => void;
};

export interface APIError extends Error {
  status: number;
  message: string;
}

export interface ErrorPageState {
  error: ErrorType;
}
